import { isServer } from './helper';

const _window = isServer ? undefined : (window as any);
export const gaConfig = () => ({
  pageview: (pageTitle, pageLocation, page, gtag) => {
    if (!isServer && _window.gtag) {
      _window.gtag('event', 'page_view', {
        page_title: pageTitle,
        page_location: pageLocation,
        page_path: page,
        send_to: gtag,
      });
    }
  },
  event: ({ eventName, ...payload }) => {
    if (!isServer && _window.gtag) {
      _window.gtag('event', eventName, {
        ...payload,
      });
    }
  },
});

// export const onHandleRouteChange = url => {
//   if (!isServer) {
//     console.log(url);
//     // gaConfig().pageview(window.origin + url);
//   }
// };

export default gaConfig;
